<template>
  <div class="content" v-loading.fullscreen.lock="loading">
    <!-- <base-header class="pb-6">
            <div class="row align-items-center py-2">
                <div class="col-lg-6 col-7"></div>
            </div>
        </base-header> -->
    <div class="row">
      <div class="col-xl-12">
        <div class="dash-head-wrap d-flex justify-content-between align-items-center">
          <div class="dash-header mb-4">
            <h2 class="text-default m-0 d-flex">Profile Info <img v-if="!isSafeDig" src="/signup-img/fire.svg" alt="">
            </h2>
            <p class="text-secondary mb-0">Explore Your Profile</p>
          </div>
          <span class="font-weight-medium font-weight-medium font-size-18 d-none d-md-block"><span
              class="requireField">*</span> Indicates a required field.</span>
          <!-- <base-button type="primary" v-if="editor === 'company' || 'manager'" @click.prevent="createuser" class="font-weight-normal px-4">Add Employee</base-button> -->
        </div>
      </div>
    </div>
    <div class="add-employee-wrap">
      <card class="no-border-card" footer-classes="pb-2">
        <!-- <template slot="header">
                    <div class="row align-items-center">
                        <div class="col-lg-6 col-12">
                            <h2 class="mb-0" v-if="!admin_adding">Edit User</h2>
                            <h2 class="mb-0" v-else>Add User</h2>
                        </div>
                        <div class="col-lg-6 col-12 text-right">
                            <h5>
                                <span class="requireField">*</span> Indicates a required field.
                            </h5>
                        </div>
                    </div>
                </template> -->

        <div class="row mb-3" v-if="!admin_adding">
          <div class="col-md-6">
            <h3 class="">
              Last Sign in:
              <span v-if="employee.last_sign_in">{{
                formattedDate(employee.last_sign_in)
                }}</span><span v-else>Never</span>
            </h3>
          </div>
          <div class="col-md-6 text-right">
            <h3>
              Type:
              <span v-if="employee.user_type === 'individual'">Individual</span>
              <span v-else>Company</span>
            </h3>
          </div>
        </div>
        <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
          <form class="general-form" @submit.prevent="handleSubmit(addUser)">
            <ul class="add-emmployee-top d-flex mb-4">
              <li class="mr-4"><span class="text-decoration-underline">Mandatory Field</span></li>
              <li class="form-radio">
                <!-- <div :class="admin_adding ? 'col-md-2' : 'col-md-2'" v-if="!employee_editing"> -->
                <div :class="admin_adding ? 'userstatus' : 'userstatus'" v-if="!employee_editing">
                  <label class="form-control-label">User Status</label>
                  <div class="d-flex">
                    <base-switch class="mr-1" type="success" v-model="employee.userstatus"></base-switch>
                  </div>
                </div>
              </li>
            </ul>
            <div class="row form-radio">
              <div :class="admin_adding ? 'col-md-6' : 'col-md-6'" class="ignore-translation">
                <label class="form-control-label">First Name <span class="requireField">*</span></label>
                <base-input type="text" class="ignore-translation" name="first name" rules="required" placeholder="First Name"
                  v-model="employee.first_name">
                </base-input>
              </div>
              <div :class="admin_adding ? 'col-md-6' : 'col-md-6'" class="ignore-translation">
                <label class="form-control-label">Last Name <span class="requireField">*</span></label>
                <base-input class="ignore-translation" type="text" name="last name" rules="required" placeholder="Last Name"
                  v-model="employee.last_name">
                </base-input>
              </div>

              <div :class="admin_adding ? 'col-md-6' : 'col-md-6'"
                v-if="!employee_editing && employee.user_type != 'individual'">
                <label class="form-control-label">User Type <span class="requireField">*</span></label>
                <br />
                <el-select class="mr-3 mb-3" name="User Type" style="width: 100%" placeholder="Select Type"
                  v-model="employee.user_type">
                  <el-option rules="required" v-for="(option, index) in user_types" class="select-primary"
                    :value="option.value" :label="option.label" :key="'user_type_' + index">
                  </el-option>
                </el-select>
              </div>
              <div class="col-md-6" v-if="employeeFieldStatus.isMandatory">
                <label class="form-control-label">Employee ID <span class="requireField">*</span></label>
                <base-input type="text" name="Employee ID" placeholder="Employee ID" rules="required"
                  v-model="employee.employee_id">
                </base-input>
              </div>
              <div class="col-md-6" v-if="admin_editing">
                <label class="form-control-label">Employee ID </label>
                <base-input type="text" name="Employee ID" placeholder="Employee ID"
                  v-model="employee.employee_id">
                </base-input>
              </div>
              <div v-if="employee_editing" class='col-md-6 ignore-translation' >
                <base-input type="text" label="User Type" placeholder="Select User Type" :disabled="disable"
                  class="employee-field" v-model="employee.user_type">
                </base-input>
              </div>

              <div :class="admin_adding ? 'col-md-6' : 'col-md-6'">
                <label class="form-control-label">Email Address<span class="requireField" v-if="
                  employee.user_type == 'admin' ||
                  employee.user_type == 'location_manager'
                ">
                    *</span></label>
                <base-input v-if="
                  employee.user_type == 'admin' ||
                  employee.user_type == 'location_manager'
                " rules="required" type="email" label="" name="Email Address" placeholder="Email"
                  v-model="employee.email">
                </base-input>
                <base-input v-else type="email" label="" name="Email Address" placeholder="Email"
                  v-model="employee.email">
                </base-input>
              </div>
              <div class="col-md-6 ignore-translation" v-if="employee_editing">
                <label class="form-control-label">Username <span class="requireField">*</span></label>
                <base-input type="text" placeholder="Username" v-model="employee.userName">
                </base-input>
                <span class="text-danger" v-if="pressed && employee.userName.length <= 0">The username field is
                  required</span>
              </div>
              <div class="col-md-6 ignore-translation" v-if="!employee_editing">
                <label class="form-control-label">Username <span class="requireField">*</span></label>
                <base-input type="text" placeholder="Username" v-model="employee.userName">
                </base-input>
              </div>

              <div :class="admin_adding ? 'col-md-6' : 'col-md-6' "
              class="ignore-translation"
                v-if="editor == 'super-admin' || editor == 'sub-admin'">
                <label class="form-control-label">Parent Location </label>

                <br />
                <el-select filterable class="mr-3" style="width: 100%" @change="childLocationsDropdown($event)"
                  v-model="employee.assignedParentLocation">
                  <el-option v-for="(option, index) in parentLocations" class="select-primary" :value="option.value"
                    :label="option.label" :key="'location_' + index">
                  </el-option>
                </el-select>
              </div>
              <!-- <div :class="admin_adding ? 'col-md-6' : 'col-md-6'" v-if="!individual_editing">
                <div v-if="!employee_editing">
                  <label class="form-control-label">Assigned Location
                    <span class="requireField" v-if="employee.user_type != 'individual'">*</span></label>
                  <br />
                  <el-select v-if="employee.user_type == 'employee'" multiple filterable class="mr-3 mb-3"
                    style="width: 100%" v-model="employee.assigned_location">
                    <el-option :disabled="employee.assigned_location.length >= 1" v-for="(option, index) in locations"
                      class="select-primary" :value="option.value" :label="option.label" :key="'location_' + index">
                    </el-option>
                  </el-select>
                  <el-select v-else multiple filterable class="mr-3 mb-3" style="width: 100%"
                    v-model="employee.assigned_location">
                    <el-option v-for="(option, index) in locations" class="select-primary" :value="option.value"
                      :label="option.label" :key="'location_' + index">
                    </el-option>
                  </el-select>
                </div>
                <div v-if="employee_editing">
                  <base-input type="text" label="Assigned Location" placeholder="Assigned Location" :disabled="disable"
                    v-model="employee.assigned_location_name">
                  </base-input>
                </div>
              </div> -->

              <div
                                :class="admin_adding ? 'col-md-6' : 'col-md-6'"
                                v-if="!individual_editing"
                                class="ignore-translation"
                            >
                                <div
                                    v-if="!employee_editing "
                                >
                                    <label class="form-control-label"
                                    >Assigned Location
                                        <span class="requireField" v-if="employee.user_type != 'individual'">*</span></label
                                    >
                                    <br/>
                                    <el-select
                                        v-if="employee.user_type == 'employee'"
                                        multiple
                                        filterable
                                        class="mr-3"
                                        style="width: 100%"
                                        v-model="employee.assigned_location"
                                    >
                                        <el-option
                                            :disabled="employee.assigned_location.length >= 1"
                                            v-for="(option, index) in locations"
                                            class="select-primary"
                                            :value="option.value"
                                            :label="option.label"
                                            :key="'location_' + index"
                                        >
                                        </el-option>
                                    </el-select>
                                    <el-select
                                        v-else
                                        multiple
                                        filterable
                                        class="mr-3"
                                        style="width: 100%"
                                        v-model="employee.assigned_location"
                                    >
                                        <el-option
                                            v-for="(option, index) in locations"
                                            class="select-primary"
                                            :value="option.value"
                                            :label="option.label"
                                            :key="'location_' + index"
                                        >
                                        </el-option>
                                    </el-select>
                                </div>
                                <div v-if="employee_editing">
                                    <base-input
                                        type="text"
                                        label="Assigned Location"
                                        placeholder="Assigned Location"
                                        :disabled="disable"
                                        v-model="employee.assigned_location_name"
                                    >
                                    </base-input>
                                </div>
                            </div>
              <div class="col-md-6" v-if="admin_adding">
                <el-popover ref="fromPopOver" placement="top-start" width="250" trigger="hover">
                  <span style="display: flex; justify-content: center">
                    You can search and select multiple courses to assign.
                  </span>
                </el-popover>
                <label style="color: #444c57" class="">Assigned Courses
                  <i v-popover:fromPopOver class="el-icon-question text-blue" />
                </label>
                <br />
                <el-select multiple filterable class="mr-3 mb-3" style="width: 100%" placeholder="Select Course"
                  v-model="employee.assigned_classes">
                  <el-option v-for="(option, index) in classes" class="select-primary" :value="option.value"
                    :label="option.label" :key="'test_question' + index">
                  </el-option>
                </el-select>
              </div>

              <div class="col-md-6" v-if="admin_adding">
                <el-popover ref="fromPopOver" placement="top-start" width="250" trigger="hover">
                  <span style="display: flex; justify-content: center">
                    You can search and select multiple course folders to assign.
                  </span>
                </el-popover>
                <label style="color: #444c57" class="">Assigned Course Folders
                  <i v-popover:fromPopOver class="el-icon-question text-blue" />
                </label>
                <br />
                <el-select multiple filterable class="mr-3" style="width: 100%" placeholder="Select Course Folders"
                  v-model="employee.courseFolders">
                  <el-option v-for="(option, index) in courseFolders" class="select-primary" :value="option.value"
                    :label="option.label" :key="'test_question' + index">
                  </el-option>
                </el-select>
              </div>


              <div class="col-md-6" v-if="!admin_adding">
                <label class="form-control-label">Password</label>
                <base-input 
                  :type="accessMasked ? 'password' : 'text'"
                  :value="isSuperAdmin ? accessCodeDisplayValue : employee.access_code"
                  @input="employee.access_code = $event"
                  placeholder="Password"
                  :readonly="isSuperAdmin && accessMasked"
                >
                  <template slot="append" v-if="isSuperAdmin">
                    <button
                      class="suffix-toggle-btn"
                      type="button"
                      @click="toggleAccess"
                      style="background: none; border: none; cursor: pointer; padding: 0;"
                    >
                      <i :class="accessMasked ? 'el-icon-view' : 'el-icon-lock'"></i>
                    </button>
                  </template>
                </base-input>
              </div>

              <div :class="admin_adding ? 'col-md-6 mt-4' : 'col-md-6'" v-if="admin_adding">
                <base-checkbox v-model="employee.password_genrate">Auto Generate password for this user
                </base-checkbox>
              </div>

              <div :class="admin_adding ? 'col-md-6 mt-2' : 'col-md-6'"
                v-if="admin_adding && !employee.password_genrate">
                <base-input type="password" label="Password" Placeholder="Enter Password"
                  v-model="employee.password"></base-input>
              </div>

              <div :class="admin_adding ? 'col-md-6 userstatus' : 'col-md-6 userstatus'" v-if="
                !employee_editing &&
                (employee.user_type == 'admin' ||
                  employee.user_type == 'location_manager')
              ">
                <label class="form-control-label">Progress Report</label>
                <div class="d-flex">
                  <base-switch class="mr-1" type="success" v-model="employee.progress"></base-switch>
                </div>
              </div>
              <div class="col-md-6" v-if="(admin_editing || employee_editing) && employee.is_rippling">
                <base-input
                  type="text"
                  label="Rippling Employee ID"
                  v-model="employee.rippling_employee_id"
                  placeholder="Rippling Employee ID"
                />
              </div>
              <div class="col-md-6" v-if="(admin_editing || employee_editing) && employee.is_paychex">
                <base-input
                  type="text"
                  label="Paychex Employee ID"
                  v-model="employee.paychex_employee_id"
                  placeholder="Paychex Employee ID"
                />
              </div>
            </div>
            <!-- <div
                                :class="admin_adding ? 'col-md-2' : 'col-md-2'"
                                v-if="!employee_editing"
                            >
                                <label class="form-control-label">User Status</label>
                                <div class="d-flex">
                                    <base-switch
                                        class="mr-1"
                                        type="success"
                                        v-model="employee.userstatus"
                                    ></base-switch>
                                </div>
                            </div> -->
            <ul class="add-emmployee-top d-flex mt-5 mb-4">
              <li class="mr-4">
                <span class="text-decoration-underline">{{ isSafeDig ? 'Safe Dig profile' : 'Optional Field' }}</span>
              </li>
            </ul>
            <p v-if="isSafeDig" class="text-secondary small mb-3">{{ $t('register.createAccountDescription') }}</p>
            <div class="row">
              <div :class="admin_adding ? 'col-md-6' : 'col-md-6'" v-if="!individual_editing">
                <div v-if="!employee_editing">
                  <label class="form-control-label">Employee Job Title</label>
                  <br />
                  <el-select class="mr-3 mb-3" style="width: 100%" placeholder="Job Title" v-model="employee.job_title"
                    filterable allow-create @change="validateJobTitle">
                    <el-option v-for="(option, index) in job_titles" class="select-primary" :value="option.value"
                      :label="option.label" :key="'job_title_' + index"></el-option>
                  </el-select>
                  <p v-if="jobTitleNotFound" class="text-danger">No job title available.</p>
                </div>
                <div v-if="employee_editing">
                  <base-input type="text" label="Job Title" placeholder="Job Title" :disabled="disable"
                    v-model="employee.job_title_label"></base-input>
                </div>
              </div>

              <template v-if="isSafeDig">
                <div :class="admin_adding ? 'col-md-6' : 'col-md-6'">
                  <label class="form-control-label">{{ $t('register.company') }}</label>
                  <base-input type="text" name="Employer company" placeholder="" v-model="employee.employer_company" />
                </div>
                <div :class="admin_adding ? 'col-md-6' : 'col-md-6'">
                  <label class="form-control-label">{{ $t('register.country') }}</label>
                  <el-select v-model="employee.country" class="w-100 mb-3" :placeholder="$t('register.selectOption')" popper-append-to-body>
                    <el-option label="United States of America" value="United States of America" />
                  </el-select>
                </div>
                <div :class="admin_adding ? 'col-md-6' : 'col-md-6'">
                  <label class="form-control-label">{{ $t('register.address') }} <span v-if="isSafeDigProfileStrict" class="requireField">*</span></label>
                  <base-input type="text" name="Address" :rules="isSafeDigProfileStrict ? 'required' : ''" placeholder="" v-model="employee.address" />
                </div>
                <div :class="admin_adding ? 'col-md-6' : 'col-md-6'">
                  <label class="form-control-label">{{ $t('register.address2') }}</label>
                  <base-input type="text" name="Address 2" placeholder="" v-model="employee.address2" />
                </div>
                <div :class="admin_adding ? 'col-md-6' : 'col-md-6'">
                  <label class="form-control-label">{{ $t('register.city') }} <span v-if="isSafeDigProfileStrict" class="requireField">*</span></label>
                  <base-input type="text" name="City" :rules="isSafeDigProfileStrict ? 'required' : ''" placeholder="" v-model="employee.city" />
                </div>
                <div :class="admin_adding ? 'col-md-6' : 'col-md-6'">
                  <label class="form-control-label">{{ $t('register.state') }} <span v-if="isSafeDigProfileStrict" class="requireField">*</span></label>
                  <el-select v-model="employee.state" class="w-100 mb-3" :placeholder="$t('register.selectOption')" popper-append-to-body>
                    <el-option v-for="s in usStates" :key="s" :label="s" :value="s" />
                  </el-select>
                </div>
                <div :class="admin_adding ? 'col-md-6' : 'col-md-6'">
                  <label class="form-control-label">{{ $t('register.zipCode') }} <span v-if="isSafeDigProfileStrict" class="requireField">*</span></label>
                  <base-input type="text" name="Zip code" :rules="isSafeDigProfileStrict ? 'required' : ''" placeholder="" v-model="employee.zipcode" />
                </div>
                <div :class="admin_adding ? 'col-md-6' : 'col-md-6'">
                  <label class="form-control-label">{{ $t('register.phone') }} <span v-if="isSafeDigProfileStrict" class="requireField">*</span></label>
                  <base-input type="text" name="Phone" :rules="isSafeDigProfileStrict ? 'required' : ''" placeholder="" v-model="employee.phone_number" @input="acceptNumber" />
                </div>
                <div :class="admin_adding ? 'col-md-6' : 'col-md-6'">
                  <label class="form-control-label">{{ $t('register.fax') }}</label>
                  <base-input type="text" name="Fax" placeholder="" v-model="employee.fax" />
                </div>
                <div :class="admin_adding ? 'col-md-6' : 'col-md-6'">
                  <label class="form-control-label">{{ $t('register.education') }} <span v-if="isSafeDigProfileStrict" class="requireField">*</span></label>
                  <el-select v-model="employee.education" class="w-100 mb-3" :placeholder="$t('register.selectOption')" popper-append-to-body>
                    <el-option v-for="key in educationOptionKeys" :key="key"
                      :label="$t('register.educationOptions.' + key)" :value="key" />
                  </el-select>
                </div>
                <div :class="admin_adding ? 'col-md-6' : 'col-md-6'">
                  <label class="form-control-label">{{ $t('register.experience') }} <span v-if="isSafeDigProfileStrict" class="requireField">*</span></label>
                  <el-select v-model="employee.experience" class="w-100 mb-3" :placeholder="$t('register.selectOption')" popper-append-to-body>
                    <el-option v-for="key in experienceOptionKeys" :key="key"
                      :label="$t('register.experienceOptions.' + key)" :value="key" />
                  </el-select>
                </div>
                <div :class="admin_adding ? 'col-md-6' : 'col-md-6'">
                  <label class="form-control-label">{{ $t('register.gender') }} <span v-if="isSafeDigProfileStrict" class="requireField">*</span></label>
                  <el-select v-model="employee.gender" class="w-100 mb-3" :placeholder="$t('register.selectOption')" popper-append-to-body>
                    <el-option v-for="key in genderOptionKeys" :key="key"
                      :label="$t('register.genderOptions.' + key)" :value="key" />
                  </el-select>
                </div>
                <div :class="admin_adding ? 'col-md-6' : 'col-md-6'">
                  <label class="form-control-label">{{ $t('register.birthYear') }} <span v-if="isSafeDigProfileStrict" class="requireField">*</span></label>
                  <el-select v-model="employee.birth_year" class="w-100 mb-3" :placeholder="$t('register.selectOption')" popper-append-to-body>
                    <el-option v-for="y in birthYears" :key="y" :label="String(y)" :value="y" />
                  </el-select>
                </div>
                <div :class="admin_adding ? 'col-md-6' : 'col-md-6'">
                  <label class="form-control-label">{{ $t('register.howDidYouHear') }} <span v-if="isSafeDigProfileStrict" class="requireField">*</span></label>
                  <el-select v-model="employee.how_did_you_hear" class="w-100 mb-3" :placeholder="$t('register.selectOption')" popper-append-to-body>
                    <el-option v-for="key in howDidYouHearOptionKeys" :key="key"
                      :label="$t('register.howDidYouHearOptions.' + key)" :value="key" />
                  </el-select>
                </div>
              </template>

              <div v-if="!isSafeDig" :class="admin_adding ? 'col-md-6' : 'col-md-6'">
                <base-input type="text" label="Phone Number" name="phone number" placeholder="(555) 555-5555"
                  v-model="employee.phone_number" @input="acceptNumber">
                </base-input>
              </div>
              <div v-if="!isSafeDig" :class="admin_adding ? 'col-md-6' : 'col-md-6'">
                <base-input type="text" label="Address" name="Address" placeholder="Address"
                  v-model="employee.address"></base-input>
              </div>
              <div v-if="!isSafeDig" :class="admin_adding ? 'col-md-6' : 'col-md-6'">
                <base-input type="text" label="City" name="City" placeholder="City" v-model="employee.city">
                </base-input>
              </div>
            </div>
            <div class="row">
              <div v-if="!isSafeDig" :class="admin_adding ? 'col-md-6' : 'col-md-6'">
                <base-input type="text" label="State" name="State" placeholder="State" v-model="employee.state">
                </base-input>
              </div>
              <div v-if="!isSafeDig" :class="admin_adding ? 'col-md-6' : 'col-md-6'">
                <base-input type="number" label="Zip Code" name="Zip code" placeholder="Zip Code"
                  v-model="employee.zipcode">
                </base-input>
              </div>
              <div v-if="!isSafeDig" :class="admin_adding ? 'col-md-6' : 'col-md-6'">
                <label class="form-control-label">Date of Birth</label>
                <el-date-picker v-model="employee.dob" placeholder="Pick a day" class="mb-3" style="width: 100%"
                  format="MM/dd/yyyy" :picker-options="pickerOptions1">
                </el-date-picker>
              </div>
              <div v-if="editor == 'super-admin' || editor == 'sub-admin'"
                :class="admin_adding ? 'col-md-6' : 'col-md-6'">
                <label class="form-control-label">Social Security Number</label>
                <base-input 
                  :type="ssnMasked ? 'password' : 'text'"
                  :value="ssnMasked ? maskedSSN : employee.social_security"
                  @input="employee.social_security = $event"
                  name="Social Security Number"
                  placeholder="Social Security"
                  :readonly="ssnMasked"
                >
                  <template slot="append">
                    <button
                      class="suffix-toggle-btn"
                      type="button"
                      @click="toggleSSN"
                      style="background: none; border: none; cursor: pointer; padding: 0;"
                    >
                      <i :class="ssnMasked ? 'el-icon-view' : 'el-icon-lock'"></i>
                    </button>
                  </template>
                </base-input>
              </div>
              <div class="col-md-6" v-if="employeeFieldStatus.isOptional">
                <label class="form-control-label">Employee ID</label>
                <base-input type="text" name="Employee ID" placeholder="Employee ID" v-model="employee.employee_id">
                </base-input>
              </div>
            </div>
            <div class="row mb-0 mb-md-2" v-if="!admin_adding">
              <div class="col-md-12">
                <div class="notification-pref-card">
                  <div>
                    <label class="form-control-label mb-1">Email Notifications</label>
                    <p class="mb-0 text-muted small">
                      Turn this off to unsubscribe this user from training and platform email notifications.
                    </p>
                  </div>
                  <label class="switch mb-0">
                    <input
                      type="checkbox"
                      v-model="notificationPreferences.emailNotifications"
                      :disabled="notificationPreferences.isLoading"
                    >
                    <span class="slider round"></span>
                  </label>
                </div>
              </div>
            </div>
            <div class="text-right mt-2">
              <router-link :hide="editor === 'employee'" :to="editor === 'super-admin' || editor === 'sub-admin'
                ? '/all_users'
                : editor === 'admin'
                  ? '/company_employees'
                  : '/dashboard'
                ">
                <base-button class="greybtn font-weight-normal px-5 mr-1 mr-sm-3">
                  Cancel
                </base-button>
              </router-link>
              <base-button type="primary" :name="admin_adding ? 'Add User ' : 'Update Profile'"
                class="font-weight-normal px-5" native-type="submit">
                {{ admin_adding ? "Submit" : "Update" }}
              </base-button>
            </div>
          </form>
        </validation-observer>
      </card>

      <card class="no-border-card" footer-classes="pb-2" v-if="!employee_editing && !admin_adding">
        <template slot="header">
          <div class="row align-items-center" v-if="!admin_adding">
            <div class="col-md-6">
              <h2 class="mb-0">Employee Courses</h2>
            </div>
            <div class="col-sm-6 text-right" v-if="!employee_editing">
              <label></label>
              <base-button @click.prevent="showAssigncourse()" type="primary">
                Assign course
              </base-button>
            </div>
          </div>
        </template>
        <div v-if="!admin_adding">
          <div>
            <div class="row" v-if="admin_adding">
              <div class="col-md-3"></div>
              <div class="col-md-6">
                <label style="color: #444c57" class="">Assigned Courses </label>

                <br />
                <el-select class="mr-3 mb-3" style="width: 100%" placeholder="Select Course"
                  v-model="employee.assigned_classes">
                  <el-option v-for="(option, index) in classes" class="select-primary" :value="option.value"
                    :label="option.label" :key="'test_question' + index">
                  </el-option>
                </el-select>
              </div>
            </div>
            <course-assignment :employee_id="this.employee_id" ref="form"></course-assignment>
          </div>
        </div>
      </card>
    </div>
    <modal :show.sync="courseAssigneeModal">
      <h3 slot="header" style="color: #444c57" class="modal-title">
        Assign Course
      </h3>
      <form>
        <div class="row">
          <div class="col-sm-12">
            <label class="form-control-label">Select any Course to Assign
            </label>
          </div>
          <div class="col-sm-12 select-style">
            <el-select multiple filterable class="company_dropdown2 w-100" v-model="assigned_course_id"
              @change="getAssignCourseId($event)" placeholder="Select Course">
              <el-option class="select-default" v-for="(course, index) in courses" :key="index" :label="course.name"
                :value="course.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="pt-2 mt-2 text-right">
          <base-button class="greybtn" @click.prevent="courseAssigneeModal = false">
            Cancel
          </base-button>
          <base-button type="primary" @click.prevent="assignCourse">
            {{ "Assign Course" }}
          </base-button>
        </div>
        <div class="clearfix"></div>
      </form>
    </modal>





  </div>
</template>
<script>
import {
  DatePicker,
  TimeSelect,
  Table,
  TableColumn,
  Select,
  Option
} from "element-ui";
import Swal from "sweetalert2";
import moment from "moment";
import CourseAssignment from "./CourseAssignment.vue";
import { formatDateLocal } from "@/util/dateFormatter";

const US_STATES = ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'];

export default {
  components: {
    CourseAssignment,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect
  },
  data() {
    return {
      ssnMasked: true,
    dlMasked: true,
    accessMasked: true,

    sensitiveLoaded: false,
    sensitiveLoading: false,
      disable: true,
      loading: false,

      assigned_course_id: "",
      pressed: false,
      courseAssigneeModal: false,
      employee_id: "",
      company_id: "",
      hot_user: "",
      hot_token: "",
      employee_editing: false,
      individual_editing: false,
      admin_adding: true,
      admin_editing: false,
      employee: {
        userName: "",
        first_name: "",
        last_name: "",
        user_type: "",
        email: "",
        address: "",
        city: "",
        state: "",
        zipcode: "",
        progress: false,
        userstatus: true,
        phone_number: "",
        assigned_location: [],
        assignedParentLocation: "",
        assigned_location_name: "",
        assignedParentLocationName: "",
        job_title: "",
        assigned_classes: "",
        courseFolders: "",
        password_genrate: "1",
        password: "",
        access_code: "",
        last_sign_in: "",
        address: "",
        dob: "",
        social_security: "",
        rippling_employee_id: "",
        is_rippling : false,
        paychex_employee_id: "",
        is_paychex: false,
        employer_company: "",
        country: "United States of America",
        address2: "",
        fax: "",
        education: "",
        experience: "",
        gender: "",
        birth_year: "",
        how_did_you_hear: "",
      },
      usStates: US_STATES,
      educationOptionKeys: ['highSchool', 'someCollege', 'associateDegree', 'bachelorDegree', 'masterOrGreater', 'other'],
      experienceOptionKeys: ['lessThan1Year', 'oneToFiveYears', 'sixToTenYears', 'tenYearsOrMore'],
      howDidYouHearOptionKeys: ['radioAd', 'printAd', 'tvAd', 'directedByAgency', 'recommendedByFriend', 'work', 'other'],
      genderOptionKeys: ['male', 'female', 'other', 'preferNotToSay'],
      editor: "",
      user_types: [],
      feildType: "password",
      super_admin: false,
      locations: [],
      parentLocations: [],
      companies: [],
      courses: [],

      classes: [],
      courseFolders: [],
      location_id: "",
      companiesList: [],
      selectedCompanyObject: {},
      isEmployeeIdVisible: {},
      pickerOptions1: {
        disabledDate(time) {
          const date = new Date();
          return time.getTime() > date.getTime() - 3600 * 1000 * 24;
        },
        shortcuts: [
          {
            text: "Today",
            onClick(picker) {
              picker.$emit("pick", new Date());
            }
          },
          {
            text: "Yesterday",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            }
          },
          {
            text: "A week ago",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            }
          }
        ]
      },
      company_name: "",
      job_titles: [],
      jobTitleNotFound: false,
      notificationPreferences: {
        emailNotifications: true,
        isLoading: false,
        suppressNextChange: false,
        isReverting: false
      }
    };
  },
  watch: {
    "employee.email": function () {
      if (this.admin_adding) {
        this.employee.userName = this.employee.email;
      }
    },
    "employee.assignedParentLocation": function (val) {

      this.selectedCompanyObject = this.companiesList.find((obj) => obj.id === val)
      // this.employee.employee_id = this.selectedCompanyObject?.employee_id

    },
    "notificationPreferences.emailNotifications": function (newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      if (this.notificationPreferences.suppressNextChange) {
        this.notificationPreferences.suppressNextChange = false;
        return;
      }
      if (this.notificationPreferences.isReverting) {
        this.notificationPreferences.isReverting = false;
        return;
      }
      if (!this.employee_id || this.admin_adding) {
        return;
      }
      this.onNotificationToggle(oldValue);
    }
  },
  created() {
    if (localStorage.getItem("hot-token")) {
      this.hot_user = localStorage.getItem("hot-user");
      this.hot_token = localStorage.getItem("hot-token");
    }
    if (localStorage.getItem("hot-user") === "employee") {
      this.company_id = localStorage.getItem("hot-company-id");
      this.employee_id = localStorage.getItem("hot-user-id");
      this.editor = "employee";
    } else if (localStorage.getItem("hot-user") === "super-admin") {
      this.editor = "super-admin";
    } else if (localStorage.getItem("hot-user") === "sub-admin") {
      this.editor = "sub-admin";
    } else if (
      localStorage.getItem("hot-user") === "company-admin" ||
      localStorage.getItem("hot-user") === "manager"
    ) {
      this.editor = "admin";
      this.company_id = localStorage.getItem("hot-user-id");
      this.childLocationsDropdown(this.company_id);
    }

    if (localStorage.getItem("hot-user") === "company-admin" || localStorage.getItem("hot-user") === "super-admin" || localStorage.getItem("hot-user") === "sub-admin") {
      this.user_types = [
        {
          label: "Admin",
          value: "admin"
        },
        {
          label: "Manager",
          value: "location_manager"
        },
        {
          label: "Employee",
          value: "employee"
        }
      ];
    } else if (localStorage.getItem("hot-user") === "manager") {
      this.user_types = [
        {
          label: "Manager",
          value: "location_manager"
        },
        {
          label: "Employee",
          value: "employee"
        }
      ];
    }

    this.feildType = this.editor === "super-admin" || this.editor === "sub-admin" ? "text" : "password";
    this.$http.get("employees/jobTitles").then(resp => {
      let jobtitle = resp.data;
      for (let data of jobtitle) {
        let obj = {
          value: data.id,
          label: data.name
        };
        this.job_titles.push(obj);
      }
    });
    if (this.$route.query.id) {
      this.loading = true;
      this.employee_id = this.$route.query.id;
      this.$http
        .get("employees/get/" + this.employee_id)
        .then(async (resp) => {
          let data = resp.data[0];

          // Admin/manager may only edit employees that belong to their assigned company/locations.
          // hot-user-id is only one of possibly many assignments (login uses first row); use API list of allowed locations.
          if (this.editor === 'admin') {
            const role = localStorage.getItem('hot-user');
            const assignedCompanyId = role === 'company-admin'
              ? localStorage.getItem('hot-user-id')
              : (localStorage.getItem('hot-admin-id') || localStorage.getItem('hot-user-id'));
            try {
              const locResp = await this.$http.post('location/all_company_location', {
                role: this.editor,
                employee_id: this.employee_id,
                company_id: this.company_id || assignedCompanyId,
              });
              const allowedIds = new Set(
                (locResp.data || []).map((loc) => String(loc.id))
              );
              const companies = data.company || [];
              const belongsToAssignedCompany = companies.some((c) => {
                if (!c || c.id == null) return false;
                const id = String(c.id);
                const parentId =
                  c.parent_id != null && Number(c.parent_id) !== 0
                    ? String(c.parent_id)
                    : '';
                return (
                  allowedIds.has(id) ||
                  (parentId !== '' && allowedIds.has(parentId))
                );
              });
              if (!belongsToAssignedCompany) {
                this.$toast.error('Not authorized', { timeout: 5000 });
                this.$router.push('/dashboard');
                return;
              }
            } catch (e) {
              this.$toast.error('Not authorized', { timeout: 5000 });
              this.$router.push('/dashboard');
              return;
            }
          }

          if (data.type === "individual") {
            this.company_id = 0;
          } else if (data.company && data.company.length) {
            let resolvedParent = null;
            for (const row of data.company) {
              if (
                row &&
                row.parent_id != null &&
                Number(row.parent_id) !== 0
              ) {
                resolvedParent = row.parent_id;
                break;
              }
            }
            const first = data.company[0];
            if (resolvedParent == null && first != null) {
              resolvedParent =
                first.parent_id != null && Number(first.parent_id) !== 0
                  ? first.parent_id
                  : first.id;
            }
            this.company_id = resolvedParent;
          }

          this.companiesList = data.company || []



          let obj = {
            last_sign_in: data.last_sign_in,
            userName: data.user_name,
            first_name: data.first_name,
            last_name: data.last_name,
            user_type: data.type,
            email: data.email,
            phone_number: data.phone_num,
            assigned_location: [],
            assignedParentLocation: "",
            job_title: data.job_title_id,
            assigned_classes: data.last_name,
            address: data.address,
            dob: data.dob,
            social_security: data.social_security,
            city: data.city,
            state: data.state,
            zipcode: data.zipcode,
            userstatus: "",
            progress: "",
            access_code: data.access_code,
            employee_id: data.employee_id, // rizz
            rippling_employee_id: data.rippling_employee_id,
            paychex_employee_id: data.paychex_employee_id,
            employer_company: data.employer_company != null ? data.employer_company : "",
            country: data.country || "United States of America",
            address2: data.address2 || "",
            fax: data.fax || "",
            education: data.education || "",
            experience: data.experience || "",
            gender: data.gender || "",
            birth_year: data.birth_year != null && data.birth_year !== "" ? data.birth_year : "",
            how_did_you_hear: data.how_did_you_hear || "",
          };

          const firstCompany = data.company && data.company[0];
          obj.is_rippling = firstCompany ? !!firstCompany.is_rippling : false;
          obj.rippling_employee_id = data.rippling_employee_id;
          obj.is_paychex = firstCompany ? !!firstCompany.is_paychex : false;
          obj.paychex_employee_id = data.paychex_employee_id;
          if (data.status === 1) {
            obj.userstatus = true;
          } else {
            obj.userstatus = false;
          }
          if (data.progress_status === 1) {
            obj.progress = true;
          } else {
            obj.progress = false;
          }
          if (data.type === "individual") {
            obj.assigned_location = [];
            obj.assignedParentLocation = "";
          } else {
            data.company.forEach((item) => {
              obj.assigned_location.push(item.id);
            });
            if (data.companyList && data.companyList.length) {
              const childRow = data.companyList.find(
                (p) => p.parent_id != null && Number(p.parent_id) !== 0
              );
              if (childRow) {
                obj.assignedParentLocation = childRow.parent_id;
              } else {
                const root = data.companyList[0];
                obj.assignedParentLocation = root ? root.id : '';
              }
            }
          }
          this.employee = obj;
          this.loadNotificationPreference();
          console.log("Rippling: "+this.employee.is_rippling);
          // "" or 0 would produce GET company/courses/ (404). Only load by company when id is a positive number.
          if (!this.hasValidCompanyCoursesId(this.company_id)) {
            console.log("this.company_id", this.company_id);
            this.$http.get("course/all_course").then(resp => {
              this.courses = resp.data;
            });
          } else {
            this.$http.get("company/courses/" + this.company_id).then(resp => {
              this.courses = resp.data[0].courses;

              this.isEmployeeIdVisible = resp.data[0]
              // console.log("resp.data[0]",  resp.data[0])
            });
            this.companyLocations();
            this.companyDropdown();
            this.parentLocationsDropdown();
          }
        })
        .finally(() => (this.loading = false));
    }
    if (this.editor === "admin" || this.editor === "super-admin" || this.editor === "sub-admin") {
      if (this.employee_id !== "") {
        this.admin_editing = true;
        this.admin_adding = false;
        this.employee_editing = false;
      } else {
        this.admin_editing = false;
        this.admin_adding = true;
        this.employee_editing = false;
      }
    } else if (this.editor === "employee") {
      this.loading = true;
      this.admin_editing = false;
      this.admin_adding = false;
      this.employee_editing = true;
      this.$http
        .get("employees/get/" + this.employee_id)
        .then(resp => {
          let data = resp.data[0];
          if (data.type === "individual") {
            this.individual_editing = true;
            this.company_id = 0;
          } else if (data.company[0] != null) {
            this.company_id = data.company[0].id;
          }

          let obj = {
            last_sign_in: data.last_sign_in,
            userName: data.user_name,
            first_name: data.first_name,
            last_name: data.last_name,
            user_type: data.type,
            email: data.email,
            phone_number: data.phone_num,
            assigned_location: "",
            assignedParentLocation: "",
            employee_company_id: data.company_id,
            job_title: data.job_title_id,
            assigned_classes: data.last_name,
            address: data.address,
            dob: data.dob,
            social_security: data.social_security,
            zipcode: data.zipcode,
            city: data.city,
            state: data.state,
            access_code: data.employee_access_code,
            assigned_location_name: "",
            assignedParentLocationName: "",
            job_title_label: "",
            employer_company: data.employer_company != null ? data.employer_company : "",
            country: data.country || "United States of America",
            address2: data.address2 || "",
            fax: data.fax || "",
            education: data.education || "",
            experience: data.experience || "",
            gender: data.gender || "",
            birth_year: data.birth_year != null && data.birth_year !== "" ? data.birth_year : "",
            how_did_you_hear: data.how_did_you_hear || "",
          };

          if (data.type === "individual") {
            this.individual_editing = true;
            obj.assigned_location = "";
            obj.assignedParentLocation = "";
          } else {
            obj.assigned_location = data.company[0].id;
            data.company.forEach(parent => {
              if (parent.parent_id != 0) {
                obj.assignedParentLocation = parent.parent_id;
              } else {
                obj.assignedParentLocation = parent.id;
              }
            });
          }
          let result = this.job_titles.find(
            ({ value }) => value === data.job_title_id
          );
          if (result) {
            obj.job_title_label = result.label;
          }
          this.employee = obj;
          this.loadNotificationPreference();
          obj.assigned_location_name = data.company[0].name;
          data.companyList.forEach(parent => {
            if (obj.assigned_location == parent.id) {
              obj.assignedParentLocationName = parent.name;
            }
          });
        })
        .finally(() => (this.loading = false));
    } else if (this.editor === "employee") {
      this.admin_editing = true;
      this.admin_adding = false;
      this.employee_editing = false;
    }
    if (this.editor != "super-admin" || this.editor === "sub-admin") {
      if (this.hasValidCompanyCoursesId(this.company_id)) {
        this.$http.get("company/courses/" + this.company_id).then(resp => {
          this.company_name = resp.data[0].name;
          this.courses = resp.data[0].courses;
          for (let obj of this.courses) {
            let classObj = {
              label: obj.name,
              value: obj.id
            };
            this.classes.push(classObj);
          }
        });
        this.$http.post("company/course_folders", {
          company_id: this.company_id,
        }).then(resp => {
          this.courseFolders = [];
          for (let data of resp.data.coursefolders) {
            let obj = {
              label: data.folder_name,
              value: data.id
            };
            this.courseFolders.push(obj);
          }
        });
        this.companyLocations();
        this.companyDropdown();
        this.parentLocationsDropdown();
      }
    }

    // To get employee id visibility
    if (localStorage.getItem("hot-user") !== "super-admin") {
      this.$http.get("company/getlogo").then(resp => {
        this.isEmployeeIdVisible = resp.data[0];
      });
    }

  },
  methods: {
    loadNotificationPreference() {
      if (!this.employee_id || this.admin_adding) {
        return;
      }
      this.notificationPreferences.isLoading = true;
      this.$http
        .get("unsubscribe/status/" + this.employee_id)
        .then(resp => {
          const isUnsubscribed = !!(resp.data && resp.data.is_unsubscribed);
          this.notificationPreferences.suppressNextChange = true;
          this.notificationPreferences.emailNotifications = !isUnsubscribed;
        })
        .finally(() => {
          this.notificationPreferences.isLoading = false;
        });
    },
    syncNotificationPreference() {
      return this.$http.post("unsubscribe/toggle", {
        user_id: this.employee_id,
        unsubscribe: !this.notificationPreferences.emailNotifications
      });
    },
    onNotificationToggle(previousValue) {
      this.notificationPreferences.isLoading = true;
      this.syncNotificationPreference()
        .then(() => {
          Swal.fire({
            title: "Notification Preferences",
            text: this.notificationPreferences.emailNotifications
              ? "Email notifications are enabled."
              : "Email notifications are disabled.",
            icon: "success",
            confirmButtonClass: "btn btn-success",
            confirmButtonText: "Ok"
          });
        })
        .catch(() => {
          this.notificationPreferences.isReverting = true;
          this.notificationPreferences.emailNotifications = previousValue;
          Swal.fire({
            title: "Error!",
            text: "Unable to update notification preference. Please try again.",
            icon: "error",
            confirmButtonClass: "btn btn-success",
            confirmButtonText: "Ok"
          });
        })
        .finally(() => {
          this.notificationPreferences.isLoading = false;
        });
    },
    async fetchSensitiveIfNeeded() {
  if (this.sensitiveLoaded || this.sensitiveLoading) return;

  try {
    this.sensitiveLoading = true;

    const resp = await this.$http.get(`/employees/${this.employee_id}/sensitive`);

    this.employee.social_security =
      resp.data.social_security || '';

    

    this.employee.access_code =
      resp.data.access_code ||
      resp.data.employee_access_code ||
      this.employee.access_code ||
      '';

    this.sensitiveLoaded = true;

  } catch (e) {
    Swal.fire({
      title: 'Access denied',
      text: 'Only super admins can view sensitive fields.',
      icon: 'error'
    });
  } finally {
    this.sensitiveLoading = false;
  }
},
async toggleAccess() {
  if (this.accessMasked) {
    await this.fetchSensitiveIfNeeded();
  }
  this.accessMasked = !this.accessMasked;
},
async toggleSSN() {
  if (this.ssnMasked) {
    await this.fetchSensitiveIfNeeded();
  }
  this.ssnMasked = !this.ssnMasked;
},
    validateJobTitle(value) {
      const jobExists = this.job_titles.some(job => job.value === value);
      this.jobTitleNotFound = !jobExists;
    },
    async companyLocations() {
     await this.$http
        .post("location/all_company_location", {
          role: this.editor,
          employee_id: this.employee_id,
          company_id: this.company_id
        })
        .then(resp => {
          this.locations = [];
          for (let loc of resp.data) {
            let obj = {
              label: loc.name,
              value: loc.id
            };
            this.locations.push(obj);
          }

          // if (
          //   this.locations.length === 1 &&
          //   this.employee.assigned_location.length < 1
          // ) {
          //   console.log("1");
          //   // this.employee.assigned_location = [];
          //   this.employee.assigned_location.push(this.locations[0].value);
          // }
        });
    },
    companyDropdown() {
      this.$http.get("company/company_dropdown").then(resp => {
        this.companies = [];
        for (let company of resp.data) {
          let obj = {
            label: company.name,
            value: company.id
          };
          this.companies.push(obj);
        }
      });
    },
    parentLocationsDropdown() {
      this.$http.get("company/parent_company_dropdown").then(resp => {
        this.parentLocations = [];
        for (let company of resp.data) {
          let obj = {
            label: company.name,
            value: company.id
          };
          this.parentLocations.push(obj);
        }
      });
    },
    async childLocationsDropdown(event) {
      // company/all_company_location
      var parentLocationId = event;
      if (parentLocationId != "") {
     await  this.$http
          .post("location/all_company_location", { company_id: parentLocationId })
          .then(resp => {
            this.locations = [];
            this.employee.assigned_location = [];
            for (let company of resp.data) {
              let obj = {
                label: company.name,
                value: company.id
              };
              this.locations.push(obj);
            }
          });
      }
    },
    acceptNumber() {
      var x = this.employee.phone_number
        .replace(/\D/g, "")
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      this.employee.phone_number = !x[2]
        ? x[1]
        : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
    },
    safedigRegisterExtras() {
      if (!this.isSafeDig) return {};
      const by = this.employee.birth_year;
      return {
        company: this.employee.employer_company,
        country: this.employee.country,
        address2: this.employee.address2,
        fax: this.employee.fax,
        education: this.employee.education,
        experience: this.employee.experience,
        gender: this.employee.gender,
        birth_year: by === "" || by === null || by === undefined ? null : Number(by),
        how_did_you_hear: this.employee.how_did_you_hear,
        address: this.employee.address,
      };
    },
    safedigUpdateExtras() {
      if (!this.isSafeDig) return {};
      const by = this.employee.birth_year;
      return {
        employer_company: this.employee.employer_company,
        country: this.employee.country,
        address2: this.employee.address2,
        fax: this.employee.fax,
        education: this.employee.education,
        experience: this.employee.experience,
        gender: this.employee.gender,
        birth_year: by === "" || by === null || by === undefined ? null : Number(by),
        how_did_you_hear: this.employee.how_did_you_hear,
      };
    },
    validateSafeDigProfile() {
      if (!this.isSafeDig) return true;
      if (this.editor === "super-admin" || this.editor === "sub-admin") return true;
      const z = (this.employee.zipcode || "").toString().trim();
      const zipOk = /^\d{5}(-\d{4})?$/.test(z);
      const phoneDigits = (this.employee.phone_number || "").replace(/\D/g, "").length;
      const by = this.employee.birth_year;
      const ok =
        (this.employee.address || "").trim() &&
        (this.employee.city || "").trim() &&
        (this.employee.state || "").trim() &&
        z &&
        zipOk &&
        phoneDigits >= 10 &&
        this.employee.education &&
        this.employee.experience &&
        this.employee.gender &&
        by !== "" &&
        by !== null &&
        by !== undefined &&
        this.employee.how_did_you_hear;
      if (!ok) {
        Swal.fire({
          title: "Required",
          text: "Please complete all Safe Dig profile fields marked with * (including a valid ZIP and 10-digit phone).",
          icon: "warning",
          confirmButtonClass: "btn btn-success",
          confirmButtonText: "Ok",
        });
      }
      return ok;
    },
    formattedDate(data) {
      return formatDateLocal(data);
    },
    showAssigncourse() {
      this.courseAssigneeModal = true;
    },
    getAssignCourseId(event) {
      this.assigned_course_id = event;
    },
    assignCourse() {
      if (this.assigned_course_id !== "") {
        let data = {
          course_id: this.assigned_course_id,
          company_id: this.company_id,
          assign_to: [
            {
              employee_ids: [],
              assign_to: "employee"
            }
          ]
        };
        let obj = {
          id: this.employee_id
        };
        data.assign_to[0].employee_ids.push(obj);
        this.$http
          .post("course/assign", data)
          .then(resp => {
            this.courseAssigneeModal = false;
            this.assigned_course_id = "";
            this.$refs.form.refresh();
            if (resp.data.alreadyPassed == 0 && resp.data.alreadyInProgress == 0) {
              Swal.fire({
                title: "Success!",
                text: "Course(s) has been Assigned to these Employee",
                icon: "success",
                confirmButtonClass: 'btn btn-success',
                confirmButtonText: 'Ok'
              });
            } else {
              Swal.fire({
                title: "Success!",
                html: '<ul style="text-align: left;"><li>Course(s) Assigned: ' + resp.data.assigned + '</li><li>Course(s) In Progress: ' + resp.data.alreadyInProgress + '</li><li>Course(s) Already Passed: ' + resp.data.alreadyPassed + '</li></ul>',
                icon: "success",
                confirmButtonClass: 'btn btn-success',
                confirmButtonText: 'Ok'
              });
            }
          })
          .catch(function (error) {
            Swal.fire({
              title: "Error!",
              html: error.response.data.message,
              icon: "error",
              confirmButtonClass: 'btn btn-success',
              confirmButtonText: 'Ok'
            });
          });
      } else {
        Swal.fire({
          title: "Error!",
          text: "All fields are required!",
          icon: "error",
          confirmButtonClass: 'btn btn-success',
          confirmButtonText: 'Ok'
        });
      }
    },
    updateEmployee(data) {
      this.$http.put("employees/update/" + this.employee_id, data)
        .then(resp => {
          Swal.fire({
            title: "Success!",
            text: `Employee has been Updated!`,
            icon: "success",
            confirmButtonClass: 'btn btn-success',
            confirmButtonText: 'Ok'
          });

          this.pressed = false;
          if (this.editor === "super-admin" || this.editor === "sub-admin") {
            this.$router.push("/all_users");
          } else {
            this.$router.push("/company_employees");
          }
        })
        .catch(error => {
          if (error.response && error.response.status === 422) {
            Swal.fire({
              title: "Error!",
              text: error.response.data.employee,
              icon: "error",
              confirmButtonClass: 'btn btn-success',
              confirmButtonText: 'Ok'
            });
          }
        })
        .finally(() => (this.loading = false));
    },

    addUser() {
      if (
        (this.editor === "admin" || this.editor === "super-admin" || this.editor === "sub-admin") &&
        this.employee.assigned_location.length == 0 &&
        this.employee.user_type != "individual"
      ) {
        return Swal.fire({
          title: "Error!",
          text: `Please assign location to user.`,
          icon: "error",
          confirmButtonClass: 'btn btn-success',
          confirmButtonText: 'Ok'
        });
      }
      this.pressed = true;

      if (this.isSafeDig && !this.validateSafeDigProfile()) {
        this.pressed = false;
        return;
      }

      this.loading = true;
      let user_status = "";
      user_status = this.employee.userstatus ? 1 : 0;
      let progress_status = "";
      progress_status = this.employee.progress ? 1 : 0;
      if (this.admin_adding) {
        let query;
        let data = {
          employee_first_name: this.employee.first_name,
          employee_last_name: this.employee.last_name,
          employee_job_title_id: this.employee.job_title,
          user_type: this.employee.user_type,
          employee_address: this.employee.address,
          employee_status: user_status,
          employee_city: this.employee.city,
          employee_state: this.employee.state,
          employee_zipcode: this.employee.zipcode,
          employee_progress: progress_status,
          employee_email: this.employee.email,
          employee_username: this.employee.userName,
          employee_phone_num: this.employee.phone_number,
          employee_company_id: this.company_id,
          employee_id: this.employee.employee_id,
          employee_location_id: this.employee.assigned_location,
          employee_course: this.employee.assigned_classes,
          courseFolders: this.employee.courseFolders,
          password: this.employee.password,
          address: this.employee.address,
          social_security: this.employee.social_security,
          dob: this.employee.dob
        };
        query = { ...data, ...this.safedigRegisterExtras() };
        this.$http
          .post("employees/register", query)
          .then(resp => {

            if (resp.data.transferEmployee == true) {
              Swal.fire({
                text: `This employee exist in another location, would you like to transfer this employee?`,
                icon: "info",
                confirmButtonClass: "btn",
                cancelButtonClass: "btn greybtn",
                confirmButtonColor: "#E0E0E0",
                cancelButtonColor: "",
                confirmButtonText: "Transfer Employee",
                showCancelButton: true,
                cancelButtonText: "Cancel",
              }).then((result) => {
                if (result.isConfirmed) {
                  query.employeeId = resp.data.employeeId;
                  this.$http.post("employees/transfer-employee", query).then(resp => {
                    if (resp.data.is_transfered) {
                      Swal.fire({
                        title: "Success!",
                        html: resp.data.message,
                        icon: "success"
                      });
                      this.$router.push("/company_employees");
                    }

                  });
                } else {

                }
              });
              return true;
            }
            Swal.fire({
              title: "Success!",
              html: resp.data.message,
              icon: "success",
              confirmButtonClass: 'btn btn-success',
              confirmButtonText: 'Ok'
            });
            if (this.editor === "super-admin" || this.editor === "sub-admin") {
              this.$router.push("/all_users");
            } else {
              this.$router.push("/company_employees");
            }
          })
          .catch(function (error) {
            if (error.response.status === 422) {
              Swal.fire({
                title: "Error!",
                html: error.response.data.message,
                icon: "error",
                confirmButtonClass: 'btn btn-success',
                confirmButtonText: 'Ok'
              });
            }
          })
          .finally(() => (this.loading = false));
      } else if (this.admin_editing) {
        // this.loading = false;
        let data = {
          employee_first_name: this.employee.first_name,
          employee_last_name: this.employee.last_name,
          employee_job_title: this.employee.job_title,
          employee_status: user_status,
          employee_type: this.employee.user_type,
          employee_email: this.employee.email,
          employee_phone_num: this.employee.phone_number,
          employee_user_name: this.employee.userName,
          employee_location_id: this.employee.assigned_location,
          employee_access_code: this.employee.access_code,
          employee_address: this.employee.address,
          employee_city: this.employee.city,
          employee_state: this.employee.state,
          employee_zipcode: this.employee.zipcode,
          employee_progress: progress_status,
          employee_id: this.employee.employee_id,
          employee_soical_security: this.employee.social_security,
          employee_dob: this.employee.dob,
          rippling_employee_id: this.employee.rippling_employee_id,
          paychex_employee_id: this.employee.paychex_employee_id,
          ...this.safedigUpdateExtras(),
        };

        if (this.employee.userstatus === false) {
          this.loading = false;
          Swal.fire({
            title: "Are you sure?",
            text: "Do you want to set this user as inactive?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonClass: 'btn btn-success',
            confirmButtonText: 'Yes, set inactive',
            cancelButtonClass: 'btn btn-danger',
            cancelButtonText: 'No, keep active'
          }).then(result => {
            if (result.isConfirmed) {
              this.updateEmployee(data);
            }
          });
        } else {
          this.updateEmployee(data);
        }
      } else if (this.employee_editing) {
        if (this.employee.userName !== "" && this.employee.access_code !== "") {
          let data = {
            employee_first_name: this.employee.first_name,
            employee_last_name: this.employee.last_name,
            employee_job_title: this.employee.job_title,
            employee_type: this.employee.user_type,
            employee_email: this.employee.email,
            employee_phone_num: this.employee.phone_number,
            employee_user_name: this.employee.userName,
            employee_location_id: this.employee.assigned_location,
            employee_access_code: this.employee.access_code,
            employee_city: this.employee.city,
            employee_soical_security: this.employee.social_security,
            employee_address: this.employee.address,
            employee_state: this.employee.state,
            employee_zipcode: this.employee.zipcode,
            employee_dob: this.employee.dob,
            employee_id: this.employee.employee_id,
            rippling_employee_id: this.employee.rippling_employee_id,
            paychex_employee_id: this.employee.paychex_employee_id,
            ...this.safedigUpdateExtras(),
          };

          this.$http
            .put("employees/update/" + this.employee_id, data)
            .then(resp => {
              this.pressed = false;
              Swal.fire({
                title: "Success!",
                text: `Your Account has been Updated!`,
                icon: "success",
                confirmButtonClass: 'btn btn-success',
                confirmButtonText: 'Ok'
              }).then(() => {
                this.$router.push("/dashboard");
              });
            })
            .finally(() => (this.loading = false));
        } else {
          this.loading = false;
          Swal.fire({
            title: "Error!",
            text: `UserName/ Password is required!`,
            icon: "error",
            confirmButtonClass: 'btn btn-success',
            confirmButtonText: 'Ok'
          });
        }
      }
    }
  },
  computed: {
    isSafeDig() {
      return process.env.VUE_APP_COMPANY_NAME_FRONTEND === 'safedig';
    },
    // Safe Dig profile required rules: company admins and employees only; super/sub-admin may save partial data.
    isSafeDigProfileStrict() {
      return (
        this.isSafeDig &&
        this.editor !== "super-admin" &&
        this.editor !== "sub-admin"
      );
    },
    birthYears() {
      const y = new Date().getFullYear();
      return Array.from({ length: 70 }, (_, i) => y - 18 - i);
    },
    isSuperAdmin() {
    return this.editor === 'super-admin';
  },

  maskedAccess() {
    const len = (this.employee.access_code || '').length || 8;
    return '*'.repeat(Math.max(4, Math.min(14, len)));
  },

  accessCodeDisplayValue() {
    if (!this.isSuperAdmin) return '';
    return this.accessMasked ? this.maskedAccess : this.employee.access_code;
  },

  maskedSSN() {
    const len = (this.employee.social_security || '').length || 9;
    return '*'.repeat(Math.max(4, Math.min(11, len)));
  },

  maskedDL() {
    const len = (this.employee.employee_driverlicence || '').length || 8;
    return '*'.repeat(Math.max(4, Math.min(14, len)));
  },
    employeeFieldStatus() {
      let isMandatory = false;
      let isOptional = false;

      if (this.isEmployeeIdVisible && this.isEmployeeIdVisible.is_check_employee_id > 0) {
        isMandatory = true;
      } else if (this.isEmployeeIdVisible && this.isEmployeeIdVisible.is_check_employee_id == 0) {
        isOptional = true;
      }
      return { isMandatory, isOptional };
    }
  },
};
</script>
<style>
.employee-field input {
  text-transform: capitalize;
}

.el-select-dropdown__list {
  padding: 6px !important;
}

@media only screen and (min-width: 280px) and (max-width: 410px) {
  .el-select-dropdown {
    left: 0 !important;
    right: 0 !important;
  }
}

@media only screen and (min-width: 411px) and (max-width: 539px) {
  .el-select-dropdown {
    left: 8px !important;
  }
}

@media only screen and (min-width: 540px) and (max-width: 767px) {
  .el-select-dropdown {
    left: 30px !important;
  }
}

@media only screen and (min-width: 768px) and (max-width: 1023px) {
  .el-select-dropdown {
    left: 158px !important;
  }
}

@media only screen and (min-width: 1024px) and (max-width: 1279px) {
  .el-select-dropdown {
    left: 284px !important;
  }
}

@media only screen and (min-width: 1280px) and (max-width: 1366px) {
  .el-select-dropdown {
    left: 415px !important;
  }
}

.suffix-toggle-btn {
  color: #8898aa;
  transition: color 0.3s ease;
}

.suffix-toggle-btn:hover {
  color: #5e72e4;
}

.suffix-toggle-btn i {
  font-size: 16px;
}

.notification-pref-card {
  border: 1px solid #dee2e6;
  border-radius: 10px;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
}

.switch {
  position: relative;
  display: inline-block;
  width: 46px;
  height: 24px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #c9ced6;
  transition: .2s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: #fff;
  transition: .2s;
}

input:checked + .slider {
  background-color: #FE672C;
}

input:focus + .slider {
  box-shadow: 0 0 1px #FE672C;
}

input:checked + .slider:before {
  transform: translateX(22px);
}

.slider.round {
  border-radius: 24px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
